const LogoSingleColor = () => (
	<svg width={24} height={24} fill="none">
		<path
			fill="#fff"
			d="M6.994 17.212c0-1.33.541-2.656 1.613-3.634 2.047-1.871 5.256-1.76 7.164.247a4.895 4.895 0 0 1 1.36 3.387h6.105l-4.89-1.624 3.466-3.87-5.126 1.001 1.022-5.024-3.928 3.38-1.678-4.853-1.678 4.852-3.929-3.38 1.014 4.981-4.898-.958 3.399 3.794-5.121 1.701h6.105Z"
		/>
	</svg>
);
export default LogoSingleColor;
